import React, { useContext, useState, useRef, useEffect } from 'react';

// CONTEXT
import { ThemeContext } from '../context/Themes';
import { SidebarContext } from '../context/Sidebar';
import { useDolar } from '../context/DolarContext';
import { useAuthStore } from "../store/auth.store.ts";

// COMPONENTS
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from "react-bootstrap";

// DATA
import {getNotificaciones} from "../api/mantenedores.ts";



export default function HeaderLayout() {

    const { theme, toggleTheme } = useContext(ThemeContext);
    const { sidebar, toggleSidebar } = useContext(SidebarContext);
    const { dolar, loading: dolarLoading } = useDolar();

    const searchRef = useRef();
    const navigate = useNavigate(); // Hook para redirigir al usuario

    const [scroll, setScroll] = useState("fixed");
    const [search, setSearch] = useState("");
    const setToken = useAuthStore((state) => state.setToken);
    const setUsuarioStore = useAuthStore((state) => state.setUsuario);
    const [notifications, setNotifications] = useState([]);

    
    const [usuario, setUsuario] = useState({});

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) setScroll("sticky");
        else setScroll("fixed");
    });

    document.addEventListener('mousedown', (event) => {
        if (!searchRef.current?.contains(event.target)) {
            setSearch("");
        }
    })

    

     useEffect(() => {
        setUsuario(useAuthStore.getState().usuario);

          const fetchNotificaciones = async () => {
            try {
                const response = await getNotificaciones();
                console.log("response", response);
                if (response.error) {
                    console.error("Error al obtener las notificaciones:", response.msg);    
                    handleLogout(); // <-- Cierra sesión y redirige al login si hay error
                    return;
                }
                setNotifications(response.data);
            } catch (error) {
                console.error("Error al obtener las notificaciones:", error);
                 handleLogout(); // <-- Cierra sesión y redirige al login si hay error
            }
      
            } 
          
          // Solo cargar notificaciones para ADMIN y MASTER
          const currentUser = useAuthStore.getState().usuario;
          if (currentUser?.roles?.[0]?.codigo === "ADMIN" || currentUser?.roles?.[0]?.codigo === "MASTER") {
              //fetchNotificaciones();

              // Actualizar notificaciones cada 5 minutos solo para ADMIN y MASTER
             /* const interval = setInterval(() => {
                  fetchNotificaciones();
              }, 300000); // 300000 ms = 5 minutos

              // Limpiar el intervalo al desmontar el componente
              return () => clearInterval(interval);*/
          }

     }, []);

     const handleLogout = () => {
        // Limpiar el estado de autenticación
        setToken("");
        setUsuarioStore(null);

        // Redirigir al usuario a la página de inicio de sesión
        navigate("/login");
    };
    return (
        <header className={`mc-header ${scroll}`}>
           
            <div className='mc-header-group'>
                <div className='mc-header-left'>
                <button type='button' className='mc-header-icon toggle' onClick={toggleSidebar}>
                        <i className="material-icons">{sidebar ? "menu_open" : "menu" }</i>
                    </button>
                </div>

                <div className='mc-header-right'>
                    <button type='button' className='mc-header-icon' >
                     Valor Dolar: ${dolar} 
                    </button>


                    <button type='button' className='mc-header-icon theme' onClick={toggleTheme}>
                        <i className="material-icons">{theme}</i>
                    </button>

                 

                    {/*================================
                          NOTIFICATION PART START
                    ================================*/}
                    {(usuario?.roles?.[0]?.codigo === "ADMIN" || usuario?.roles?.[0]?.codigo === "MASTER") && (
                    <Dropdown className='notify'>
                        <Dropdown.Toggle className="mc-dropdown-toggle mc-header-icon">
                            <i className='material-icons'>notifications</i>
                            <sup className='primary'>{notifications.length}</sup>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" className="mc-dropdown-paper">
                            <div className="mc-header-dropdown-group">
                                <div className="mc-card-header">
                                    <h4 className="mc-card-title">
                                       Notificaciones
                                        ({notifications.length})
                                    </h4>
                                    <Dropdown bsPrefix="mc-dropdown">
                                        
                                    </Dropdown>
                                </div>

                                <ul className="mc-header-dropdown-list thin-scrolling">
                                    {notifications?.map((notification, index) => (
                                        <li key={index} className={`mc-header-dropdown-item ${notification.isActive && 'active'}`}>
                                            <Link to='#' className='mc-header-dropdown-content'>

                                                <div className="mc-header-dropdown-notify-media">
                                                     <img src="images/logo.png" alt="avatar" />
                                                    
                                                </div>


                                                <div className="mc-header-dropdown-meta">
                                                    <h4>
                                                        <span dangerouslySetInnerHTML={{ __html: 'El apoderado <b>'+notification?.nomapoderado+' '+notification?.apeapoderado+'</b> ha realizado un pago para el alumno <b>'+notification?.nomalumno+' '+notification?.apealumno+'</b> del Establecimiento <b>'+notification?.establecimiento+' Curso '+notification?.curso+'</b>'}} />
                                                    </h4>
                                                    <p>{notification?.longMoment}</p>
                                                </div>

                                            </Link>

                                            
                                        </li>
                                    ))}
                                </ul>

                               
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    )}
                    {/*================================
                          NOTIFICATION PART END
                    ================================*/}


                    {/*================================
                            PROFILE PART START
                    ================================*/}
                    <Dropdown className="mc-header-user">
                        <Dropdown.Toggle className="mc-dropdown-toggle">
                            <Link to='#' className='mc-round-avatar xs'>
                            <img src="images/LogoEmail.png" alt="avatar" />
                            </Link>
                            <div className='mc-duel-text xs'>
                                <h3 className="mc-duel-text-title">Hola: {usuario.nombre}</h3>
                               
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" className="mc-dropdown-paper">
                            <Link to='/mi-cuenta' className='mc-dropdown-menu'><i className='material-icons'>person</i><span>Mi cuenta</span></Link>
                           
                            <button onClick={handleLogout} className='mc-dropdown-menu'><i className='material-icons'>lock</i><span>Salir</span></button>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/*================================
                            PROFILE PART END
                    ================================*/}

                </div>
            </div>
        </header>
    );
}

